import { Link } from 'react-router-dom';
import { compact, bytes } from './ModelSpecs';

const VISIBILITY_TONE = {
  private: 'border-[#383f38] text-[#888888]',
  unlisted: 'border-[#4a514a] text-[#bbbbbb]',
  public: 'border-white/40 text-white',
};

// A model as one row of a list. In the workspace (`own`) the creator is you, so the row
// says who can see it instead.
export default function CheckpointCard({ checkpoint, own = false }) {
  const {
    checkpoint_id, name, creator_username, creator_verified, corpus_tags = [],
    bytes_seen, parameters, runtime_id, soma_version, download_count = 0, star_count = 0, visibility,
  } = checkpoint;
  const runtime = (runtime_id || soma_version || 'legacy').replace(/^soma\./, '').toLowerCase();
  const stats = [
    parameters ? `${compact(parameters)} params` : null,
    `${bytes(bytes_seen || 0)} seen`,
    runtime,
    star_count > 0 ? `${star_count} ★` : null,
    download_count > 0 ? `${download_count.toLocaleString()} ↓` : null,
  ].filter(Boolean);
  return (
    <Link to={`/checkpoints/${checkpoint_id}`} className="group block py-5" data-testid={`checkpoint-card-${checkpoint_id}`}
      aria-label={`model: ${name} by ${creator_username}, ${stats.join(', ')}`}>
      <div className="flex items-baseline gap-3">
        <h3 className="font-mono text-white lowercase text-lg lg:text-xl truncate group-hover:underline underline-offset-4 decoration-[#444444]">{name}</h3>
        {own ? (
          <span className={`ml-auto shrink-0 font-mono text-[10px] lowercase px-2 py-0.5 rounded border ${VISIBILITY_TONE[visibility] || VISIBILITY_TONE.private}`}
            data-testid="model-visibility">{visibility}</span>
        ) : (
          <span className="ml-auto shrink-0 font-mono text-[11px] text-[#666666] lowercase flex items-center gap-1.5">
            {creator_username}
            {creator_verified && <img src="/phi-logo-64.png" alt="verified" title="verified" className="verified-badge" />}
          </span>
        )}
      </div>
      <p className="font-mono text-xs text-[#888888] mt-1.5 flex flex-wrap gap-x-3 gap-y-1">
        {stats.map((t, i) => <span key={i}>{t}</span>)}
      </p>
      {corpus_tags.length > 0 && (
        <p className="font-mono text-[11px] text-[#555555] lowercase mt-2 flex flex-wrap gap-x-3">
          {corpus_tags.slice(0, 6).map((t) => <span key={t}>#{t}</span>)}
        </p>
      )}
    </Link>
  );
}
